/* eslint-disable import/no-anonymous-default-export */
import _ from 'lodash'
export default ({ month, language = 'TH'}) => {
  switch (_.toString(month)) {
    case '1':
    case '01': return language === 'TH' ? 'มกราคม' : 'January'
    case '2':
    case '02': return language === 'TH' ? 'กุมภาพันธ์' : 'February'
    case '3':
    case '03': return language === 'TH' ? 'มีนาคม' : 'March'
    case '4':
    case '04': return language === 'TH' ? 'เมษายน' : 'April'
    case '5':
    case '05': return language === 'TH' ? 'พฤษภาคม' : 'May'
    case '6':
    case '06': return language === 'TH' ? 'มิถุนายน' : 'June'
    case '7':
    case '07': return language === 'TH' ? 'กรกฏาคม' : 'July'
    case '8':
    case '08': return language === 'TH' ? 'สิงหาคม' : 'August'
    case '9':
    case '09': return language === 'TH' ? 'กันยายน' : 'September'
    case '10': return language === 'TH' ? 'ตุลาคม' : 'October'
    case '11': return language === 'TH' ? 'พฤศจิกายน' : 'November'
    case '12': return language === 'TH' ? 'ธันวาคม' : 'December'
    default: return ''
  }
}
